import { Avatar } from "@admin/components/atoms/Avatar";
import { useLogout } from "@admin/hooks/useLogout";
import { getUser, useAuthStore, useLanguageStore } from "@enos-monorepo/lib";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

export function SidebarFooter() {
  const languageOptions = [
    { displayName: "Danish", i18Name: "da", svgName: "denmark" },
    { displayName: "Turkish", i18Name: "tr", svgName: "turkey" },
    { displayName: "English", i18Name: "en", svgName: "united-states" },
  ];
  const { t } = useTranslation();
  const { language: storedLanguage, setLanguage } = useLanguageStore();
  const logout = useLogout();
  const { user } = useAuthStore();
  const { data } = useQuery({
    queryKey: ["user", user?.id],
    queryFn: () => getUser(user?.id ?? ""),
    enabled: !!user,
  });

  return (
    <div
      className="flex flex-center justify-between shrink-0 ps-4 pe-3.5 mb-3.5"
      id="sidebar_footer"
    >
      <div className="menu" data-menu="true">
        <div
          className="menu-item"
          data-menu-item-offset="-10px, 15px"
          data-menu-item-placement="right-end"
          data-menu-item-toggle="dropdown"
          data-menu-item-trigger="click|lg:click"
        >
          <div className="menu-toggle btn btn-icon rounded-full">
            <Avatar
              size="sm"
              alt={`${data?.firstName} ${data?.lastName}`}
              className="size-8 rounded-full justify-center border border-gray-500 shrink-0"
              src={data?.avatarPhotoPath}
            />
          </div>
          <div className="menu-dropdown menu-default light:border-gray-300 w-screen max-w-[250px]">
            <div className="flex items-center justify-between px-5 py-1.5 gap-1.5">
              <div className="flex flex-col gap-1.5">
                <span className="text-sm text-gray-800 font-semibold leading-none">
                  {data?.firstName} {data?.lastName}
                </span>
                <span className="text-xs text-gray-600 font-medium leading-none">
                  {data?.email}
                </span>
              </div>
              <Avatar
                alt={`${data?.firstName} ${data?.lastName}`}
                className="border-2 border-success"
                src={data?.avatarPhotoPath}
              />
            </div>
            <div className="menu-separator"></div>
            <div className="flex flex-col">
              <div
                className="menu-item"
                data-menu-item-offset="-10px, 0"
                data-menu-item-placement="left-start"
                data-menu-item-toggle="dropdown"
                data-menu-item-trigger="click|lg:hover"
              >
                <div className="menu-link">
                  <span className="menu-icon">
                    <i className="ki-filled ki-icon"></i>
                  </span>
                  <span className="menu-title">
                    {t("profile.Change Language")}
                  </span>
                  <div className="flex items-center gap-1.5 rounded-md border border-gray-300 text-gray-600 p-1.5 text-2xs font-medium shrink-0">
                    {
                      languageOptions.find(
                        (language) => language.i18Name === storedLanguage,
                      )?.displayName
                    }
                    <img
                      alt=""
                      className="inline-block size-3.5 rounded-full"
                      src={`/media/flags/${languageOptions.find((language) => language.i18Name === storedLanguage)?.svgName}.svg`}
                    />
                  </div>
                </div>
                <div className="menu-dropdown menu-default light:border-gray-300 w-full max-w-[170px]">
                  {languageOptions.map((language, index) => (
                    <div
                      key={index}
                      className={`menu-item ${language.i18Name === storedLanguage ? "active" : ""}`}
                    >
                      <button
                        className="menu-link h-10"
                        onClick={() => setLanguage(language.i18Name)}
                      >
                        <span className="menu-icon">
                          <img
                            alt=""
                            className="inline-block size-4 rounded-full"
                            src={`/media/flags/${language.svgName}.svg`}
                          />
                        </span>
                        <span className="menu-title">
                          {language.displayName}
                        </span>
                        {language.i18Name === storedLanguage && (
                          <span className="menu-badge">
                            <i className="ki-solid ki-check-circle text-success text-base"></i>
                          </span>
                        )}
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="flex flex-col">
              <div className="menu-item px-4 py-1.5">
                <button
                  onClick={logout}
                  className="btn btn-sm btn-light justify-center"
                >
                  {t("auth.Log out")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-1.5">
        <button
          className="btn btn-icon btn-icon-lg size-8 hover:bg-light hover:text-primary text-gray-600"
          onClick={logout}
        >
          <i className="ki-filled ki-exit-right"></i>
        </button>
      </div>
    </div>
  );
}
